let TooltipHorizontalOffset;
(function (TooltipHorizontalOffset) {
  TooltipHorizontalOffset[TooltipHorizontalOffset["Left"] = 0] = "Left";
  TooltipHorizontalOffset[TooltipHorizontalOffset["Right"] = 1] = "Right";
  TooltipHorizontalOffset[TooltipHorizontalOffset["Center"] = 2] = "Center";
})(TooltipHorizontalOffset || (TooltipHorizontalOffset = {}));
let TooltipVerticalOffset;
(function (TooltipVerticalOffset) {
  TooltipVerticalOffset[TooltipVerticalOffset["Above"] = 0] = "Above";
  TooltipVerticalOffset[TooltipVerticalOffset["Below"] = 1] = "Below";
  TooltipVerticalOffset[TooltipVerticalOffset["Inline"] = 2] = "Inline";
  TooltipVerticalOffset[TooltipVerticalOffset["Center"] = 3] = "Center";
})(TooltipVerticalOffset || (TooltipVerticalOffset = {}));

export { TooltipHorizontalOffset, TooltipVerticalOffset };
